import { Link } from "react-router-dom";

export function NotFoundPage() {
  return (
    <main className="not-found" id="main-content">
      <span className="brand-tile large-brand">R</span>
      <p className="eyebrow">页面不存在</p>
      <h1>这里没有保存的机会</h1>
      <p>链接可能已经变化，或者你没有访问这个工作区资源的权限。</p>
      <Link className="button primary" to="/jobs">
        返回职位列表
      </Link>
    </main>
  );
}
